import * as React from 'react';
import styled from 'styled-components';
import DotButton, { Position } from './DotButton';
import { DisablableOption } from '../../../models/Option';

const RadioButtons = ({ options, currentValue, onClick, asOneButton }: Props) => {
	return (
		<Buttons leftAligned={!asOneButton}>
			{options.map((option: unknown, i: number) => {
				const text = typeof option === 'string' ? option : (option as DisablableOption<unknown>).text;
				const value = typeof option === 'string' ? option : (option as DisablableOption<unknown>).value;
				const disabled = typeof option === 'string' ? false : (option as DisablableOption<unknown>).disabled;
				let position: Position = null;
				if (options.length !== 1) {
					if (i === 0) {
						position = 'first';
					} else if (i === options.length - 1) {
						position = 'last';
					} else {
						position = 'middle';
					}
				}

				return (
					<DotButton
						key={text}
						text={text}
						value={value}
						data-value={value.toString()}
						selected={value === currentValue}
						position={position}
						onClick={() => {
							if (currentValue !== value) {
								onClick(value);
							}
						}}
						disabled={disabled}
						showBorders={asOneButton}
					/>
				);
			})}
		</Buttons>
	);
};

interface Props {
	options: string[] | DisablableOption<unknown>[];
	currentValue: unknown;
	onClick: (value: unknown) => void;
	asOneButton?: boolean;
}

RadioButtons.defaultProps = {
	asOneButton: true
};

export default RadioButtons;

const Buttons = styled.div<{ leftAligned: boolean }>`
	${(props) => (props.leftAligned ? 'text-align: left;' : '')}
`;
